import React from 'react';
import { ServiceIconShell, ServiceIcon as DefaultServiceIcon, } from '@zapier/design-system';
const getPropsWithDefaults = (props) => (Object.assign({ ariaHidden: false, hasBorder: true }, props));
function stripVersion(key) {
    key = key || '';
    return key.split('@')[0];
}
/**
 * We're using className to generate the
 *
 * Tags: services, icons
 */
export const ServiceIcon = (_props) => {
    const props = getPropsWithDefaults(_props);
    const { alt, ariaHidden, hasBorder, hasShadow, serviceName, size, src, } = props;
    const iconSize = Math.ceil(0.7 * size);
    const serviceNameNoVersion = stripVersion(serviceName);
    return (React.createElement("div", null, src ? (React.createElement(DefaultServiceIcon, { alt: alt, ariaHidden: ariaHidden, hasBorder: hasBorder, hasShadow: hasShadow, serviceName: serviceName, size: size, src: src })) : (React.createElement(ServiceIconShell, { hasBorder: hasBorder, hasShadow: hasShadow, size: size },
        React.createElement("div", { className: `PlaceholderAPI64x64 ${serviceNameNoVersion}64x64 app-logo img64 zap-icons__icon`, style: { height: iconSize, width: iconSize } })))));
};
